"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const ToolTip_1 = __importDefault(require("./ToolTip/ToolTip"));
const styles = (0, react_1.css) `
  background-color: #f5f5f5;
  border: none;
  border-radius: 5px;
  padding: 5px;

  &:hover {
    background-color: lightgray !important;
    color: black !important;
  }

  &.toggle-active {
    background-color: gray;
    color: white;
  }
`;
function ToggleButton({ children, style = {}, onClick = () => null, popupTitle = '', popupPlacement = 'right', defaultValue = false, disabled = false, className = '', }) {
    const [flag, toggle] = (0, react_2.useState)(defaultValue);
    const toggleHandler = (0, react_2.useCallback)(() => {
        onClick(!flag);
        toggle(!flag);
    }, [onClick, flag]);
    return ((0, jsx_runtime_1.jsx)(ToolTip_1.default, { title: popupTitle, popupPlacement: popupPlacement, children: (0, jsx_runtime_1.jsx)("button", { disabled: disabled, css: styles, style: style, className: (flag ? 'toggle toggle-active ' : 'toggle ') + className, type: "button", onClick: toggleHandler, children: children }) }));
}
exports.default = (0, react_2.memo)(ToggleButton);
